import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs';
import { NgxSpinnerModule } from 'ngx-spinner';

import { OfferService } from '../../_services/offer/offer.service';
import { ThemeService } from '../../_services/theme.service';

@Component({
  selector: 'app-offer-link-redirect',
  standalone: true,
  imports: [CommonModule, NgxSpinnerModule],
  templateUrl: './offer-link-redirect.component.html',
  styleUrl: './offer-link-redirect.component.scss',
})
export class OfferLinkRedirectComponent implements OnInit {
  themeReady = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private offerService: OfferService,
    private themeService: ThemeService,
  ) {}

  ngOnInit(): void {
    this.waitForThemeReady();

    this.themeService.restorePersistedThemeOrApply(null, 'zen').finally(() => {
      this.themeReady = this.themeService.isThemeReady();
    });

    const propId = this.route.snapshot.paramMap.get('prop_id') ?? '';
    const key = this.route.snapshot.paramMap.get('key') ?? '';

    const conf_num = this.route.snapshot.queryParamMap.get('conf_num') ?? undefined;
    const dt_arrival = this.route.snapshot.queryParamMap.get('dt_arrival') ?? undefined;
    const los = this.route.snapshot.queryParamMap.get('los') ?? undefined;
    const base_room_type_idn = this.route.snapshot.queryParamMap.get('base_room_type_idn') ?? undefined;
    const email = this.route.snapshot.queryParamMap.get('email') ?? undefined;
    const ofrOrigin = this.route.snapshot.queryParamMap.get('ofr_origin') ?? 'DPS';

    if (!propId || !key) {
      console.warn('[OfferLinkRedirect] Missing required route params. Redirecting to offerNotAvailable.');
      this.router.navigate(['/offerNotAvailable']);
      return;
    }

    this.offerService
      .resolveAliasFromLink({
        prop_id: propId,
        key,
        conf_num,
        dt_arrival,
        los,
        base_room_type_idn,
        email,
        ofr_origin: ofrOrigin,
      })
      .pipe(take(1))
      .subscribe({
        next: aliasId => {
          console.debug('[OfferLinkRedirect] Resolved alias id', { aliasId, propId });
          this.router.navigate(['/offer', aliasId, propId], { replaceUrl: true });
        },
        error: (error) => {
          console.error('[OfferLinkRedirect] Failed to resolve alias link. Redirecting to offerNotAvailable.', error);
          this.router.navigate(['/offerNotAvailable']);
        },
      });
  }

  private waitForThemeReady(): void {
    this.themeReady = this.themeService.isThemeReady();

    if (this.themeReady) {
      return;
    }

    this.themeService.themeReady$.pipe(take(1)).subscribe(isReady => {
      this.themeReady = isReady;
    });
  }
}
